"use client";

import type { ToolRegistryItem } from "@/types/tools";
import { useFavorites } from "./local-tool-storage";
import { ToolCard } from "./tool-card";

type FavoriteToolsSectionProps = {
  tools: ToolRegistryItem[];
};

export function FavoriteToolsSection({ tools }: FavoriteToolsSectionProps) {
  const { favorites } = useFavorites();
  const favoriteTools = favorites
    .map((id) => tools.find((tool) => tool.id === id))
    .filter((tool): tool is ToolRegistryItem => Boolean(tool));

  if (!favoriteTools.length) {
    return (
      <div className="rounded-lg border border-dashed border-zinc-300 bg-white px-4 py-8 text-center">
        <p className="text-sm font-medium text-zinc-900">No favorites yet.</p>
        <p className="mt-1 text-sm text-zinc-500">
          Star tools you use often and they will stay on this device.
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {favoriteTools.map((tool) => (
        <ToolCard key={tool.id} tool={tool} />
      ))}
    </div>
  );
}
